<template>
  <div class="step__block-field">
    <h3>subTotal:</h3>

    <div class="step__block-field-block summary">
      <div>
        <span class="step__block-field-block center">
          {{ totalSquare }}
        </span>
      </div>
      <div class="step__block-field-price container">
        <PriceValue
          v-if="showOldSubtotalPrice"
          :price="oldSubtotalPrice"
          class="step__block-field-price old-price"
        />
        <PriceValue
          :price="subtotalPrice"
          class="step__block-field-price right"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch, ref } from "vue";
import { Pricing } from "@/app/domain";
import { PriceValue } from "@/shared";

import { PricingService } from "@/app/services/pricing.service";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useInstallationStore } from "@/stores/new/installation.store";

const estimateStore = useNewEstimateStore();
const newInstallationStore = useInstallationStore();

const pricingService = new PricingService();
const dealType = computed(() => estimateStore.estimate.dealTypeCode);

const showOldSubtotalPrice = ref(false);
const oldSubtotalPrice = computed(() => newInstallationStore.oldSubtotalPrice);
const subtotalPrice = computed(() => newInstallationStore.subtotalPrice);
const totalSquare = computed(() => newInstallationStore.totalSquare);

const updateSubtotalPrices = () => {
  const updatedOldSubtotalPrice =
    pricingService.calculateInstallationOldSubtotalPrice();
  const formattedOldSubtotalPrice = new Pricing(
    updatedOldSubtotalPrice.price,
    updatedOldSubtotalPrice.priceB2C,
    updatedOldSubtotalPrice.priceB2B,
  );
  newInstallationStore.oldSubtotalPrice = formattedOldSubtotalPrice;

  const updatedSubtotalPrice =
    pricingService.calculateInstallationSubtotalPrice();
  const formattedSubtotalPrice = new Pricing(
    updatedSubtotalPrice.price,
    updatedSubtotalPrice.priceB2C,
    updatedSubtotalPrice.priceB2B,
  );
  newInstallationStore.subtotalPrice = formattedSubtotalPrice;
};
watch(
  () => newInstallationStore.installationItemList,
  () => {
    updateSubtotalPrices();
  },
  {
    deep: true,
  },
);
watch(
  () => [oldSubtotalPrice.value, subtotalPrice.value],
  () => {
    const oldSubtotal = oldSubtotalPrice.value.getSystemPrice(
      dealType.value,
    ).price;
    const subtotal = subtotalPrice.value.getSystemPrice(dealType.value).price;

    showOldSubtotalPrice.value = oldSubtotal < subtotal;
  },
  {
    deep: true,
  },
);
</script>

<style scoped>
.step__block-field {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 15px 0;
  border-top: 1px solid #d2d8e3;
  border-bottom: 1px solid #d2d8e3;
}

.step__block-field-block {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.step__block-field-block.center {
  justify-content: center;
}

.step__block-field-block.summary {
  display: flex;
  align-items: center;
  width: 45%;
}

.step__block-field h3 {
  color: #404d63;
  font-family: Gilroy;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.step__block-field-price {
  color: #404d63;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.step__block-field-price.old-price {
  display: flex;
  align-items: center;
  column-gap: 4px;
  min-width: max-content;

  font-family: Gilroy;
  color: #404d63bf;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  text-decoration: line-through;
}

.step__block-field-price.right {
  display: block;
  width: 100%;

  text-align: right;
  line-height: 18px;
}

.step__block-field-price.container {
  display: flex;
  column-gap: 10px;
  align-items: flex-end;
}
</style>
